export default __webpack_public_path__ + "images/pictograms/change-user-info.svg?be3fb419fd6b2f7d9ec70fbaf4bbc4b053fdeb8349173a64feed222ff0795f6c";